import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import "./index.css";

class TauSocialWidget extends Component {
  render() {
    return (
      <div className="row mt-4">
        <div className="col-12">
          <div
            className="tau-social-col  p-3"
            style={{
              background: "var(--cardBg)",
              border: "var(--card-border)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            <div className="market-inner-col d-flex justify-content-between mb-3">
              <span className="badge badge-warning market-bedge">
                Tau.social top posts
              </span>
              <img
                className="img-fluid"
                src={require("../../assets/icons/share-icon.svg")}
                alt="share"
              />
            </div>

            <div className="social-reddit-link">
              <p style={{ color: "var(--pColor)" }}>
                links from{" "}
                <a href="#" style={{ color: "var(--a)" }}>
                  tau.social
                </a>
              </p>

              <p className="coming-soon mt-5 mb-5 text-center">
                COMING SOON ...
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TauSocialWidget;
